import React, { useState } from 'react';
import { Form, Input, Button, Radio } from 'antd';
import { Link, useHistory } from 'react-router-dom';
import { useForm } from 'antd/lib/form/Form';
import { LockOutlined, MailOutlined } from '@ant-design/icons';
import { dispatch, useGlobalState } from '../../store/state';
import { SignInBrandOrAgency } from '../../apis/Signin';
import { BrandPhoneSignInFormComponent } from './BrandPhoneSignInFormComponent';

const { Item } = Form;
export const BrandSignInFormComponent = () => {
  const history = useHistory();
  const [user] = useGlobalState('user');
  const [BrandAgencySignInForm] = useForm();
  const [loginOpts, setLoginOpts] = useState({
    activeType: 'email',
    options: [
      { label: 'Email Login', value: 'email' },
      { label: 'Phone Login', value: 'phone' },
    ],
  });
  const [apiValidation, setApiValidation] = useState({
    success: false,
    points: [],
  });
  const onChangeLoginType = (e) =>{
    // console.log("change in type to",e.target.value)
    setLoginOpts({
      ...loginOpts,
      activeType: e.target.value,
    });
  };

  // @note: this is the default email singin in option on sucess redirect to dashboard
  const onFinish = (values) => {
    if (apiValidation.error) {
      setApiValidation({
        success: false,
        points: [],
      });
    }
    SignInBrandOrAgency(values).then((result) => {
      // console.log("server result",result)
      if (result.status === 200) {
        setApiValidation({
          success: true,
          points: [],
        });
        dispatch({
          type: 'SET_USER',
          payload: {
            ...user,
            ...result.response,
          },
        });
        BrandAgencySignInForm.resetFields();

        setTimeout(() => {
          history.push('/brand');
        }, 0);
      } else if (result.status === 400 || result.status === 422) {
        const _msgs = [];
        result.response.errors.forEach((error) => {
          _msgs.push(error.msg);
          return null;
        });
        setApiValidation({
          success: false,
          points: _msgs,
        });
      } else {}
    });
  };

  return (
    <div>
      <div className="pb-3">
        <Radio.Group
          options={loginOpts.options}
          onChange={onChangeLoginType}
          value={loginOpts.activeType}
          optionType="button"
          buttonStyle="solid"
        />
      </div>
      {loginOpts.activeType === 'email' ?( // login using email
        <Form
          form={BrandAgencySignInForm}
          name="signin_brand_agency_form"
          className="login-form"
          initialValues={{
            remember: true,
          }}
          onFinish={onFinish}
        >
          <Item
            name="email"
            rules={[
              {
                required: true,
                message: 'Please provide your Email ID!',
              },
            ]}
          >
            <Input
              className="common_input"
              type="email"
              size="large"
              prefix={<MailOutlined className="site-form-item-icon" />}
              placeholder="Work Email Address" />
          </Item>

          <Item
            name="password"
            rules={[
              {
                required: true,
                message: 'Please input your Password!',
              },
            ]}
          >
            <Input.Password
              className="common_input"
              size="large"
              prefix={<LockOutlined className="site-form-item-icon" />}
              // type="password"
              placeholder="Password"
            />
          </Item>
          <div className="pb-3 text-right c_m_neg_10">
            <Link type="text"
              className="p-0"
              to="/signin/brand-agency/reset">
              <Button type="text"
                className="px-0">Forgot passowrd?</Button>
            </Link>
          </div>
          <Item className="mb-1">
            <Button type="primary"
              htmlType="submit"
              className="common_button">
                        Sign In
            </Button>
            <span className="pl-3">Don't have account?</span>
            <Link to="/signup">
              <Button className="px-0"
                type="link">Signup Now</Button>
            </Link>
          </Item>

        </Form>
      ):null
      }{
        // @note: Phone OTP login Option
        loginOpts.activeType === 'phone'?(
          <BrandPhoneSignInFormComponent apiValidation={apiValidation}
            setApiValidation={setApiValidation}/>
        ):null
      }
      {
        // @note: validation status for email related Login
        apiValidation.points.length ?
          <div>
            <p className="text-danger mb-1"><strong>Failed to Sign In due to following reasons:</strong></p>
            <ul className="pl-3">
              {apiValidation.points.map((point, index) =>(
                <li key={index}
                  className="text-danger">{point}</li>
              ))}
            </ul>
          </div> :
          null
      }
      {apiValidation.success && <h6 className="text-success mb-1">Sign In completed successfully!</h6>}
    </div>
  );
};
